import { Component, inject, signal } from '@angular/core';

import { SingleSpaLoaderService } from '@shared/lib/services';
//import { EmbedMicroappDirective } from '@shared/public-api';

import { HeaderComponent } from '../../header/header.component';
import { HoldsNotificationComponent } from '../../holds-notification/holds-notification.component';
import { LeftNavigationComponent } from '../../left-navigation/left-navigation.component';
import { ProfileTrayComponent } from '../../profile-tray/profile-tray.component';
import { ToasterNotificationComponent } from '../../toaster-notification/toaster-notification.component';
import { BottomSheetLayoutComponent } from '../bottom-sheet-layout/bottom-sheet-layout.component';

@Component({
  selector: 'wu-authenticated-layout',
  imports: [
    LeftNavigationComponent,
    HeaderComponent,
    BottomSheetLayoutComponent,
    ProfileTrayComponent,
    HoldsNotificationComponent,
    ToasterNotificationComponent,
  ],
  templateUrl: './authenticated-layout.component.html',

  styleUrl: './authenticated-layout.component.scss',
})
export class AuthenticatedLayoutComponent {
  readonly mobileNavIsOpened = signal(false);
  readonly profileTrayIsOpened = signal(false);
  readonly isMicroappMode = inject(SingleSpaLoaderService).isFullScreen;
}
